export class MaritalStatus {
  civilStatusId!: string;
  name!: string;
}
